export default __webpack_public_path__ + "aa9a29988561df22f7f4557121004168.png";